import { Dashboard, Report } from '@/types';

export const normalizeReportDashboard = (report: Report, fallbackDashboard?: Dashboard): Report => {
    const dashboard = report.dashboard ?? fallbackDashboard;

    if (!dashboard) {
        return report;
    }

    return {
        ...report,
        dashboard: {
            ...dashboard,
            // A report only needs its parent identity. Keeping the parent's
            // nested collection here would create a recursive object graph.
            reports: [],
        },
    };
};
